import { type ReactNode } from 'react';
import { cn } from '@/utils/cn';

export function Spinner({ className }: { className?: string }): ReactNode {
  return (
    <div className={cn('flex items-center justify-center py-3xl', className)}>
      <div className="h-9 w-9 rounded-full border-[3px] border-surface-secondary border-t-brand-red animate-spin" />
    </div>
  );
}

export function SpinnerInline({ size = 14 }: { size?: number }): ReactNode {
  return (
    <div
      className="rounded-full border-2 border-current/30 border-t-current animate-spin"
      style={{ width: size, height: size }}
    />
  );
}
